<template>
  <div>
    <ip-whitelisting
      v-if="activeIPTab === 'create'"
      @view="setCurrentTab('view')"
    />
    <ip-address-list v-else @create="setCurrentTab('create')" />
  </div>
</template>
<script>
export default {
  name: 'IPWhitelist',
  components: {
    IpWhitelisting: () =>
      import(
        '@/components/v2/settings/apiSettings/ipWhitelist/IpWhitelisting.vue'
      ),
    IpAddressList: () =>
      import(
        '@/components/v2/settings/apiSettings/ipWhitelist/IpAddressList.vue'
      )
  },
  data () {
    return {
      isLoading: false,
      activeIPTab: 'create'
    }
  },
  methods: {
    setCurrentTab (tab) {
      this.activeIPTab = tab
    }
  }
}
</script>
